<template>
  <button type="button" :class="classNames" :style="styles" @click.stop="clickEvent"></button>
</template>

<script>
export const StockButtonType = Object.freeze({
  plus: 'plus',
  minus: 'minus',
  exit: 'exit'
})

export default {
  name: 'VStockButton',
  props: {
    type: {
      type: String,
      required: true
    },
    clickEvent: {
      type: Function,
      required: true
    },
    inactive: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 30
    },
    height: {
      type: Number,
      default: 30
    }
  },
  computed: {
    classNames() {
      return ['default', this.type, this.inactive ? 'inactive' : '']
    },
    styles() {
      return {
        borderRadius: this.type !== StockButtonType.exit ? `${this.width}px` : 0,
        minWidth: `${this.width}px`,
        minHeight: `${this.height}px`,
        '--widthSize': this.width,
        '--heightSize': this.height
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.default {
  cursor: pointer;
}

.inactive {
  cursor: default;
}

.plus {
  background-image: url('~@/assets/images/stock-plus@2x.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 14px 14px;

  &.inactive {
    background-image: url('~@/assets/images/stock-plus-off@2x.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 14px 14px;
  }
}

.minus {
  background-image: url('~@/assets/images/stock-minus@2x.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 14px 14px;

  &.inactive {
    background-image: url('~@/assets/images/stock-minus-off@2x.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 14px 14px;
  }
}

.exit {
  width: calc(var(--widthSize) * 1px);
  height: calc(var(--heightSize) * 1px);
  background-image: url('~@/assets/images/icon-close@2x.png');
  background-size: 16px 16px;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
